// extracted by mini-css-extract-plugin
module.exports = {"container":"_4d935d0799--container--sRm2K","icon":"_4d935d0799--icon--YAVZQ","name":"_4d935d0799--name--SzG0M"};